import { LocationOption, vehImglocationsDesc as desc } from 'remarketing-angular-library';

export const locationList: LocationOption[] = [{
  description: desc.CARGO_AREA,
  code: 'CRGO'
},
{
  description: desc.INTERIOR,
  code: 'INT'
},
{
  description: desc.FRONT_CORNER,
  code: 'FC'
},
{
  description: desc.FRONT,
  code: 'FRNT'
},
{
  description: desc.LEFT_SIDE,
  code: 'LS'
},
{
  description: desc.ODOMETER,
  code: 'ODO'
},
{
  description: desc.REAR_CORNER,
  code: 'RC'
},
{
  description: desc.REAR,
  code: 'REAR'
},
{
  description: desc.RIGHT_SIDE,
  code: 'RS'
},
{
  description: desc.RIM_OR_TIRE,
  code: 'TIRE'
},
{
  description: desc.THIRD_ROW_SEAT,
  code: '3RS'
},
{
  description: desc.VIN_PLATE_OR_STICKER,
  code: 'VIN'
},
{
  description: desc.TIRE_FRONT_LEFT,
  code: 'FL'
},
{
  description: desc.TIRE_FRONT_RIGHT,
  code: 'FR'
},
{
  description: desc.TIRE_REAR_LEFT,
  code: 'RL'
},
{
  description: desc.TIRE_REAR_RIGHT,
  code: 'RR'
},
{
  description: desc.TIRE_SPARE,
  code: 'SP'
},
{
  description: desc.OTHER,
  code: 'OT'
}];

export const defaultLocationCodes = ['CRGO', 'INT', 'FC', 'FRNT', 'LS', 'ODO', 'RC', 'REAR', 'RS', 'TIRE', '3RS', 'VIN', 'OT', ''];
export const tireLocationCodes = ['FL', 'FR', 'RL', 'RR', 'SP'];
export const allLocationCodes = [...defaultLocationCodes, ...tireLocationCodes];
